import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationType } from 'src/app/enum/notification-type.enum';
import { ComboDetails } from 'src/app/models/commission/combo-details.model';
import { KomFeed } from 'src/app/models/commission/kom-feed.model';
import { CustomHttpRespone } from 'src/app/models/customhttpresponse/custom-http-response';
import { UpdateManualDataModel } from 'src/app/models/upload/update_manual_data.model';
import { NotificationService } from 'src/app/service/notification.service';
import { UpdateManualDataService } from 'src/app/service/update-manual-data.service';

@Component({
  selector: 'app-update-goals-edit',
  templateUrl: './update-goals-edit.component.html',
  styleUrls: ['./update-goals-edit.component.css']
})
export class UpdateGoalsEditComponent implements OnInit {
  public goalsUpdateModel = new UpdateManualDataModel();
  public kpisList: UpdateManualDataModel[] = [];
  public complansList: UpdateManualDataModel[] = [];
  public calrunidsList: UpdateManualDataModel[] = [];
  public header: string = 'Edit Goals';

  public comboDtl = new ComboDetails();
  public oolDetails: KomFeed[] = [];

  constructor(private updateManualDataService: UpdateManualDataService,
    private notificationService: NotificationService, private router: Router) { }

  ngOnInit(): void {
    this.getCalRunIds();
    this.getCommPlans();
    this.getKpis();

    console.log(this.updateManualDataService.editGoalsModel);
    this.goalsUpdateModel = this.updateManualDataService.editGoalsModel;

    console.log(this.goalsUpdateModel);
  }

  public update() {
    console.log("update Called: " + JSON.stringify(this.goalsUpdateModel));
    this.updateManualDataService.updateGoalByID(this.goalsUpdateModel).subscribe(
      (response: CustomHttpRespone) => {
        this.router.navigate(['/update-goal-results']);
        this.notificationService.sendNotification(NotificationType.SUCCESS, response.message);
      },
      (error: HttpErrorResponse) => {
        this.notificationService.sendNotification(NotificationType.ERROR, error.error.message);
      }
    )
  }


  public getCalRunIds(): void {
    console.log("getActiveCorps called");
    this.updateManualDataService.getCalRunIds().subscribe(
      (response: UpdateManualDataModel[]) => {
        this.calrunidsList = response;
        this.calrunidsList = this.calrunidsList.filter((v, i) => this.calrunidsList.findIndex(item => item.calrunid == v.calrunid) === i);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }

  public getCommPlans(): void {
    console.log("getCommPlans called");
    this.updateManualDataService.getCommPlans().subscribe(
      (response: UpdateManualDataModel[]) => {
        this.complansList = response;
        // console.log(this.complansList);
        this.complansList = this.complansList.filter((v, i) => this.complansList.findIndex(item => item.commplanid == v.commplanid) === i);
        // console.log(this.complansList);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }

  public getKpis(): void {
    console.log("getKpis called");
    this.updateManualDataService.getKpis('Goals').subscribe(
      (response: UpdateManualDataModel[]) => {
        this.kpisList = response;
        //console.log(this.kpisList);
        this.kpisList = this.kpisList.filter((v, i) => this.kpisList.findIndex(item => item.kpiid == v.kpiid) === i);
        //console.log(this.kpisList);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }

  public back() {
    this.router.navigate(['/update-goal-results']);
  }

  redirect() {
    this.router.navigate(['/update-manual-data']);
  }



}



